import { render, staticRenderFns } from "./ThemeSettingsDirectRight.vue?vue&type=template&id=47a84586&scoped=true"
import script from "./ThemeSettingsDirectRight.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a84586",
  null
  
)

export default component.exports